var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15624_9872)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.16675 3.33203H3.33341C2.89139 3.33203 2.46746 3.50763 2.1549 3.82019C1.84234 4.13275 1.66675 4.55667 1.66675 4.9987V16.6654C1.66675 17.1074 1.84234 17.5313 2.1549 17.8439C2.46746 18.1564 2.89139 18.332 3.33341 18.332H15.0001C15.4421 18.332 15.866 18.1564 16.1786 17.8439C16.4912 17.5313 16.6667 17.1074 16.6667 16.6654V10.832",
    stroke: "#56585A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4167 2.08417C15.7483 1.75265 16.1979 1.56641 16.6667 1.56641C17.1356 1.56641 17.5852 1.75265 17.9167 2.08417C18.2483 2.41569 18.4345 2.86533 18.4345 3.33417C18.4345 3.80301 18.2483 4.25265 17.9167 4.58417L10.0001 12.5008L6.66675 13.3342L7.50008 10.0008L15.4167 2.08417Z",
    stroke: "#56585A",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15624_9872"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.d10fa5fa8aa190f5cd28ef508940ed74.svg";
export { ForwardRef as ReactComponent };